import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SubscriptionForm from './SubscriptionForm';

class New extends Component {
  render() {
    const {
      isModalOpen,
      onCloseHandler,
      onSubmitHandler,
      error,
      submitting,
    } = this.props;

    return (
      <SubscriptionForm
        isModalOpen={isModalOpen}
        onCloseHandler={onCloseHandler}
        onSubmitHandler={onSubmitHandler}
        error={error}
        submitting={submitting}
      />
    );
  }
}

New.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  onSubmitHandler: PropTypes.func,
  error: PropTypes.string,
  submitting: PropTypes.bool,
};

New.defaultProps = {
  isModalOpen: false,
  onCloseHandler: () => {},
  onSubmitHandler: () => {},
  error: null,
  submitting: false,
};

export default New;
